import 'arrive';
import $ from 'jquery';

/**
 * Navbar Mega Menu JavaScript
 * Handles keyboard navigation, accessibility, and scroll behavior
 */

document.arrive('.block-header', { existing: true }, function () {
    const $win = $(window);
    const $header = $('.block-header');
    if (!$header.length) return;

    // Selector per i link interni al mega menu (supporta entrambe le classi)
    const MENU_LINK_SELECTOR = '.mega-menu-link, .mega-menu-card-link';

    // Scroll behavior variables
    let lastY = $win.scrollTop();
    let ticking = false;
    const HIDE_THRESHOLD = 10;
    const TOP_REVEAL = 50;

    // Initialize mega menu functionality
    initMegaMenu();
    initScrollBehavior();

    function getMegaMenuFullHeight($megaMenu) {
        const $cards = $megaMenu.find('.mega-menu-item');

        // salva stili cards
        const cardStyles = [];
        $cards.each(function () {
            cardStyles.push(this.style.cssText);
            this.style.transform = 'none';
            this.style.opacity = '1';
        });

        // salva stile mega
        const originalStyle = $megaMenu[0].style.cssText;

        // forza stato finale per misurazione
        $megaMenu.css({
            height: 'auto',
            paddingTop: '48px',
            paddingBottom: '48px',
            visibility: 'visible',
            opacity: 1
        });

        const height = $megaMenu[0].scrollHeight;

        // ripristino
        $megaMenu[0].style.cssText = originalStyle;
        $cards.each(function (i) {
            this.style.cssText = cardStyles[i];
        });

        return height;
    }

    function showMegaMenuCards($megaMenu) {
        const $cards = $megaMenu.find('.mega-menu-item');

        $cards.each(function (index) {
            const card = this;
            setTimeout(() => {
                card.classList.add('is-visible');
            }, index * 120);
        });
    }

    function hideMegaMenuCards($megaMenu) {
        const $cards = $megaMenu.find('.mega-menu-item').get().reverse();

        $cards.forEach((card, index) => {
            setTimeout(() => {
                card.classList.remove('is-visible');
            }, index * 80);
        });
    }

    /**
     * Initialize mega menu interactions and accessibility
     */
    function initMegaMenu() {
        const $megaMenuItems = $('.mega-menu-item');

        if ($megaMenuItems.length) {
            setupKeyboardNavigation($megaMenuItems);
            setupMegaMenuInteractions($megaMenuItems);
            setupFocusManagement($megaMenuItems);
        }

        setupEscapeKeyHandling($megaMenuItems);
    }

    /**
     * Setup keyboard navigation for mega menu
     */
    function setupKeyboardNavigation($megaMenuItems) {
        $megaMenuItems.each(function() {
            const $item = $(this);
            const $trigger = $item.find('.nav-link');
            const $megaMenu = $item.find('.mega-menu');

            if (!$trigger.length || !$megaMenu.length) return;

            // Handle keyboard events on trigger
            $trigger.on('keydown', function(e) {
                switch(e.key) {
                    case 'Enter':
                    case ' ':
                        e.preventDefault();
                        toggleMegaMenu($item, $trigger, $megaMenu);
                        break;
                    case 'ArrowDown':
                        e.preventDefault();
                        openMegaMenu($item, $trigger, $megaMenu);
                        focusFirstMenuItem($megaMenu);
                        break;
                    case 'ArrowRight':
                        e.preventDefault();
                        focusNextMainMenuItem($trigger);
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        focusPreviousMainMenuItem($trigger);
                        break;
                }
            });

            // Setup mega menu item navigation
            setupMegaMenuItemNavigation($megaMenu);
        });
    }

    /**
     * Setup navigation within mega menu items
     */
    function setupMegaMenuItemNavigation($megaMenu) {
        const $menuLinks = $megaMenu.find(MENU_LINK_SELECTOR);

        $menuLinks.each(function(index) {
            const $link = $(this);

            $link.on('keydown', function(e) {
                switch(e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        focusNextMenuItem($menuLinks, index);
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        focusPreviousMenuItem($menuLinks, index);
                        break;
                    case 'ArrowRight':
                        e.preventDefault();
                        focusNextColumn($megaMenu, $link);
                        break;
                    case 'ArrowLeft':
                        e.preventDefault();
                        focusPreviousColumn($megaMenu, $link);
                        break;
                    case 'Escape':
                        e.preventDefault();
                        closeMegaMenu($megaMenu.closest('.mega-menu-item'));
                        break;
                }
            });
        });
    }

    /**
     * Setup mega menu hover and focus interactions
     */
    function setupMegaMenuInteractions($megaMenuItems) {
        $megaMenuItems.each(function() {
            const $item = $(this);
            const $trigger = $item.find('.nav-link');
            const $megaMenu = $item.find('.mega-menu');

            if (!$trigger.length || !$megaMenu.length) return;

            // Click toggle only (no hover open/close)
            $trigger.on('click', function(e) {
                e.preventDefault();
                toggleMegaMenu($item, $trigger, $megaMenu);
            });


        });
    }

    /**
     * Setup focus management
     */
    function setupFocusManagement($megaMenuItems) {
        $(document).on('keydown', function(e) {
            if (e.key === 'Tab') {
                const $openMegaMenu = $('.mega-menu:visible');
                if ($openMegaMenu.length) {
                    trapFocusInMegaMenu(e, $openMegaMenu);
                }
            }
        });
    }

    /**
     * Setup escape key handling
     */
    function setupEscapeKeyHandling($megaMenuItems) {
        $(document).on('keydown', function(e) {
            const isEscape = e.key === 'Escape' || e.key === 'Esc' || e.which === 27 || e.keyCode === 27;
            if (isEscape) {
                // Close any open mega menus
                closeAllMegaMenus($megaMenuItems);
            }
        });
    }

    /**
     * Toggle mega menu open/closed
     */
    function toggleMegaMenu($item, $trigger, $megaMenu) {
        const isOpen = $item.hasClass('is-open') || $trigger.attr('aria-expanded') === 'true';
        if (isOpen) {
            // Sempre chiudi su click se è aperto (anche se aperto da hover)
            // e sopprimi l'hover finché non si esce realmente con il mouse,
            // oltre a rimuovere il focus dal trigger per non lasciare focus "appiccicato"
            closeMegaMenu($item, { suppressHover: true, blurTrigger: true });
        } else {
            // Apri su click e mantieni aperto anche su mouseleave
            openMegaMenu($item, $trigger, $megaMenu, { openByClick: true });
        }
    }

    /**
     * Open mega menu
     */
    function openMegaMenu($item, $trigger, $megaMenu, options = {}) {
        const { openByClick = false } = options;

        const $openItems = $('.mega-menu-item.is-open').not($item);
        const isFirstOpen = $openItems.length === 0;

        /* ======================================================
        CASO 1 — SWITCH tra mega-menu già aperti
        ====================================================== */
        if (!isFirstOpen) {

            // 1. dissolve le cards dei menu aperti in reverse
            $openItems.each(function () {
                const $oldMega = $(this).find('.mega-menu');
                hideMegaMenuCards($oldMega);
            });

            // 2. calcola durata totale dello stagger
            let maxCards = 0;
            $openItems.each(function () {
                const cardsCount = $(this).find('.mega-menu-item').length;
                if (cardsCount > maxCards) maxCards = cardsCount;
            });
            const staggerDuration = maxCards * 100 + 100; // 100ms per card + buffer

            // 3. prepara il nuovo mega-menu (invisible cards)
            const fullHeight = getMegaMenuFullHeight($megaMenu) + 'px';
            $megaMenu.css({
                height: fullHeight,
                paddingTop: '48px',
                paddingBottom: '48px',
                opacity: 1,
                visibility: 'visible'
            });
            $item.addClass('is-open');
            $trigger.attr('aria-expanded', 'true');

            // 4. dopo che lo stagger reverse è terminato, rimuovo vecchi mega-menu e mostro le cards nuove
            setTimeout(() => {
                $openItems.each(function () {
                    const $oldItem = $(this);
                    $oldItem
                        .removeClass('is-open')
                        .find('.nav-link')
                        .attr('aria-expanded', 'false');
                    $(this).find('.mega-menu').css({
                        visibility: 'hidden',
                        opacity: 0,
                        height: 0,
                        paddingTop: 0,
                        paddingBottom: 0
                    });
                });

                // ora mostro le cards del nuovo menu
                requestAnimationFrame(() => {
                    showMegaMenuCards($megaMenu);
                });
            }, staggerDuration);

            // stati globali
            $header.addClass('is-hovered');
            $('body').addClass('has-mega-overlay');

            // tabindex link interni
            $megaMenu.find(MENU_LINK_SELECTOR).attr('tabindex', '0');

            return;
        }

        /* ======================================================
        CASO 2 — PRIMA apertura (SLIDE-DOWN)
        ====================================================== */

        const fullHeight = getMegaMenuFullHeight($megaMenu) + 'px';

        $megaMenu.css({
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0,
            visibility: 'visible'
        });

        $item.addClass('is-open');
        $trigger.attr('aria-expanded', 'true');

        // force reflow
        $megaMenu[0].offsetHeight;

        $megaMenu.css({
            height: fullHeight,
            paddingTop: '48px',
            paddingBottom: '48px',
            opacity: 1
        });

        setTimeout(() => {
            showMegaMenuCards($megaMenu);
        }, 400);

        $header.addClass('is-hovered');
        $('body').addClass('has-mega-overlay');

        $megaMenu.find(MENU_LINK_SELECTOR).attr('tabindex', '0');
    }

    /**
     * Close mega menu
     */
    function closeMegaMenu($item, options = {}) {
        const {
            suppressHeaderUpdate = false,
            suppressBodyUpdate = false,
            suppressHover = false,
            blurTrigger = false
        } = options;

        const $trigger = $item.find('.nav-link');
        const $megaMenu = $item.find('.mega-menu');

        const wasOpen = $item.hasClass('is-open');

        if ($trigger.length) $trigger.attr('aria-expanded', 'false');
        $item.removeClass('is-open');
        $item.data('openByClick', false);

        if ($megaMenu.length) {
            const $menuLinks = $megaMenu.find(MENU_LINK_SELECTOR);
            $menuLinks.attr('tabindex', '-1');

            // Nascondi le cards con dissolve
            hideMegaMenuCards($megaMenu);

            // Reset altezza e padding per slide-down successivo
            $megaMenu.css({
                height: 0,
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0,
                visibility: 'hidden'
            });
        }

        if (suppressHover) {
            $item.data('preventHover', true).addClass('suppress-hover');
            $item.one('mouseleave', function() {
                $item.data('preventHover', false).removeClass('suppress-hover');
            });
        }

        if (blurTrigger && $trigger.length) $trigger.trigger('blur');

        // Rimuovi header/overlay solo se nessun menu rimane aperto
        const anyOpenAfter = $('.mega-menu-item.is-open').length > 0;
        if (wasOpen && !anyOpenAfter) {
            if (!suppressHeaderUpdate) $header.removeClass('is-hovered');
            if (!suppressBodyUpdate) $('body').removeClass('has-mega-overlay');
        }

        // Se trigger aveva il focus, torna al trigger
        if (!blurTrigger && $(document.activeElement).closest($item).length && document.activeElement !== $trigger[0]) {
            $trigger.focus();
        }
    }

    /**
     * Close all mega menus except the specified one
     */
    function closeOtherMegaMenus($exceptItem) {
        $('.mega-menu-item').each(function() {
            const $item = $(this);
            if (!$item.is($exceptItem)) {
                closeMegaMenu($item, { suppressHeaderUpdate: true, suppressBodyUpdate: true });
            }
        });
    }

    /**
     * Close all mega menus
     */
    function closeAllMegaMenus($megaMenuItems) {
        // Close all and suppress hover to avoid immediate reopen
        $megaMenuItems.each(function() {
            closeMegaMenu($(this), { suppressHeaderUpdate: true, suppressBodyUpdate: true, suppressHover: true, blurTrigger: true });
        });
        // Then remove global states once
        $header.removeClass('is-hovered');
        $('body').removeClass('has-mega-overlay');
    }

    /**
     * Focus management helpers
     */
    function focusFirstMenuItem($megaMenu) {
        const $firstLink = $megaMenu.find(MENU_LINK_SELECTOR).first();
        if ($firstLink.length) $firstLink.focus();
    }

    function focusNextMenuItem($menuLinks, currentIndex) {
        const nextIndex = (currentIndex + 1) % $menuLinks.length;
        $menuLinks.eq(nextIndex).focus();
    }

    function focusPreviousMenuItem($menuLinks, currentIndex) {
        const prevIndex = currentIndex === 0 ? $menuLinks.length - 1 : currentIndex - 1;
        $menuLinks.eq(prevIndex).focus();
    }

    function focusNextMainMenuItem($currentTrigger) {
        const $triggers = $('.main-nav .nav-link');
        const currentIndex = $triggers.index($currentTrigger);
        const nextIndex = (currentIndex + 1) % $triggers.length;
        $triggers.eq(nextIndex).focus();
    }

    function focusPreviousMainMenuItem($currentTrigger) {
        const $triggers = $('.main-nav .nav-link');
        const currentIndex = $triggers.index($currentTrigger);
        const prevIndex = currentIndex === 0 ? $triggers.length - 1 : currentIndex - 1;
        $triggers.eq(prevIndex).focus();
    }

    function focusNextColumn($megaMenu, $currentLink) {
        const $columns = $megaMenu.find('.mega-menu-column');
        const $currentColumn = $currentLink.closest('.mega-menu-column');
        const currentColumnIndex = $columns.index($currentColumn);

        if ($columns.length) {
            if (currentColumnIndex < $columns.length - 1) {
                const $nextColumn = $columns.eq(currentColumnIndex + 1);
                const $firstLink = $nextColumn.find(MENU_LINK_SELECTOR).first();
                if ($firstLink.length) $firstLink.focus();
            }
        } else {
            // Nessuna colonna: passa al link successivo nella griglia
            const $links = $megaMenu.find(MENU_LINK_SELECTOR);
            const idx = $links.index($currentLink);
            if (idx > -1 && idx < $links.length - 1) {
                $links.eq(idx + 1).focus();
            }
        }
    }

    function focusPreviousColumn($megaMenu, $currentLink) {
        const $columns = $megaMenu.find('.mega-menu-column');
        const $currentColumn = $currentLink.closest('.mega-menu-column');
        const currentColumnIndex = $columns.index($currentColumn);


        if ($columns.length) {
            if (currentColumnIndex > 0) {
                const $prevColumn = $columns.eq(currentColumnIndex - 1);
                const $firstLink = $prevColumn.find(MENU_LINK_SELECTOR).first();
                if ($firstLink.length) $firstLink.focus();
            }
        } else {
            // Nessuna colonna: passa al link precedente nella griglia
            const $links = $megaMenu.find(MENU_LINK_SELECTOR);
            const idx = $links.index($currentLink);
            if (idx > 0) {
                $links.eq(idx - 1).focus();
            }
        }
    }



    /**
     * Trap focus within mega menu
     */
    function trapFocusInMegaMenu(e, $megaMenu) {
        const $focusableElements = $megaMenu.find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
        const $firstElement = $focusableElements.first();
        const $lastElement = $focusableElements.last();

        if (e.shiftKey) {
            if ($(document.activeElement).is($firstElement)) {
                e.preventDefault();
                $lastElement.focus();
            }
        } else {
            if ($(document.activeElement).is($lastElement)) {
                e.preventDefault();
                $firstElement.focus();
            }
        }
    }

    /**
     * Initialize scroll behavior (original functionality)
     */
    function initScrollBehavior() {
        // Usiamo direttamente l'evento scroll di Lenis (che hai già inizializzato globalmente)
        // Se 'lenis' è in un altro file, assicurati che sia accessibile (es. window.lenis)
        
        let lastY = 0;
        const HIDE_THRESHOLD = 5;

        lenis.on('scroll', (e) => {
            const y = e.scroll;
            const delta = y - lastY;

            // 1. Cima della pagina
            if (y < 80) {
                $header.removeClass('is-hidden is-sticky has-shadow');
                lastY = y;
                return;
            }

            // 2. Scroll Down: Nascondi
            if (delta > HIDE_THRESHOLD) {
                if (!$header.hasClass('is-hovered')) {
                    $header.addClass('is-hidden').removeClass('is-sticky has-shadow');
                }
            } 
            // 3. Scroll Up: Mostra
            else if (delta < -HIDE_THRESHOLD) {
                $header.removeClass('is-hidden').addClass('is-sticky has-shadow');
            }

            lastY = y;
        });
    }

    // Chiudi i mega-menu cliccando fuori dall'header
    $(document).on('click', function(e) {
        const $target = $(e.target);

        if (!$target.closest('.block-header').length) {
            const $openItems = $('.mega-menu-item.is-open');

            $openItems.each(function() {
                const $item = $(this);
                const $megaMenu = $item.find('.mega-menu');

                // 1️⃣ Stagger reverse delle cards
                hideMegaMenuCards($megaMenu);

                // 2️⃣ Calcola durata dello stagger
                const cardsCount = $megaMenu.find('.mega-menu-item').length;
                const staggerDuration = cardsCount * 100 + 100; // ms

                // 3️⃣ Dopo lo stagger, slide-up del mega-menu
                setTimeout(() => {
                    // forza altezza attuale
                    const currentHeight = $megaMenu[0].scrollHeight + 'px';
                    $megaMenu.css({
                        height: currentHeight,
                        paddingTop: $megaMenu.css('paddingTop'),
                        paddingBottom: $megaMenu.css('paddingBottom'),
                        opacity: 1,
                        transition: 'height 400ms ease, padding 400ms ease, opacity 400ms ease'
                    });

                    // Trigger reflow
                    $megaMenu[0].offsetHeight;

                    // Slide-up
                    $megaMenu.css({
                        height: 0,
                        paddingTop: 0,
                        paddingBottom: 0,
                        opacity: 0
                    });

                    $item.removeClass('is-open');
                    $item.find('.nav-link').attr('aria-expanded', 'false');

                    // 4️⃣ Dopo la transizione, rimuovi overlay e header
                    setTimeout(() => {
                        $megaMenu.css({ visibility: 'hidden', transition: '' });
                        $header.removeClass('is-hovered');
                        $('body').removeClass('has-mega-overlay');
                    }, 400); // deve corrispondere alla durata della transizione

                }, staggerDuration);
            });
        }
    });

});

